import DeleteLoanOutstanding from "./DeleteLoanOutstanding";

export default DeleteLoanOutstanding;
